module.exports = __webpack_public_path__ + "static/img/avatar.a610902.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar.jpg
// module id = jpVj
// module chunks = 34